import MagnifyingGlassFingerprintIcon from './MagnifyingGlassFingerprintIcon'

export default MagnifyingGlassFingerprintIcon
